import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";

function DatenschutzPage() {
  return (
    <div className="min-h-screen p-4 pb-24 bg-gray-50 dark:bg-gray-900">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="w-full max-w-md mx-auto bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 mt-8"
      >
        <h2 className="text-xl font-bold mb-4 text-gray-800 dark:text-white flex items-center">
          <ShieldCheck className="mr-2 text-green-600" size={20} />
          Datenschutzerklärung
        </h2>
        
        <div className="space-y-4 text-gray-600 dark:text-gray-300 text-sm">
          <div>
            <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">1. Datenschutz auf einen Blick</h3>
            <p className="mb-2">
              Diese App-Datenschutzerklärung klärt Sie über die Art, den Umfang und Zwecke der Erhebung 
              und Verwendung personenbezogener Daten durch den THC-Rechner auf.
            </p>
            <p>
              Der THC-Rechner ist datenschutzfreundlich gestaltet und speichert Ihre eingegebenen Daten 
              ausschließlich lokal auf Ihrem Gerät. Es findet keine Übertragung Ihrer Daten an Server statt.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">2. Lokale Datenspeicherung</h3>
            <p>
              Die App speichert folgende Informationen ausschließlich lokal auf Ihrem Gerät:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Ihre Einwilligung zum Disclaimer (in localStorage)</li>
              <li>Temporäre Berechnungsergebnisse während der Nutzungssession</li>
            </ul>
            <p className="mt-2">
              Diese Daten werden nicht an externe Server gesendet und sind nur für Sie auf Ihrem Gerät zugänglich.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">3. Ihre Rechte</h3>
            <p>
              Da die App keine personenbezogenen Daten sammelt oder verarbeitet außer der lokalen 
              Speicherung auf Ihrem Gerät, können Sie jederzeit:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Die App deinstallieren, um alle gespeicherten Daten zu entfernen</li>
              <li>Den Browser-Cache und lokalen Speicher löschen, um alle gespeicherten Informationen zu entfernen</li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">4. Kontakt</h3>
            <p>
              Bei Fragen zur Verarbeitung Ihrer persönlichen Daten können Sie sich an uns wenden:
            </p>
            <p className="mt-2">
              E-Mail: datenschutz@thc-rechner-app.de
            </p>
          </div>
          
          <div className="pt-2">
            <p className="italic text-gray-500 dark:text-gray-400">
              Stand: November 2023 - Diese Datenschutzerklärung ist ein Beispiel und sollte für den 
              produktiven Einsatz an Ihre spezifischen Anforderungen angepasst werden.
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default DatenschutzPage;